import { render, staticRenderFns } from "./InviteAccount.vue?vue&type=template&id=52be55ad&"
import script from "./InviteAccount.vue?vue&type=script&lang=js&"
export * from "./InviteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports